import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ModalComponent } from "../../../../../shared/components/modal";

@Component({
  selector: 'facturar',
  imports: [CommonModule, ModalComponent],
  templateUrl: './facturar.component.html',
  styleUrl: './facturar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FacturarComponent {

  private _isOpen = signal(false);
  email = signal('facturacion@subito.com.mx');

  mailtoHref(): string {
    const subject = encodeURIComponent('Solicitud de facturación');
    const body = encodeURIComponent(this.composeEmailBody());
    return `mailto:${this.email()}?subject=${subject}&body=${body}`;
  }

  private composeEmailBody(): string {
    return (
      'Hola equipo de facturación,\n\n' +
      'Envío la solicitud de facturación del pedido.\n\n' +
      'Datos requeridos:\n' +
      '- Número de pedido: \n' +
      '- RFC: \n' +
      '- Código Postal: \n' +
      '- Régimen Fiscal: \n\n' +
      'Gracias.'
    );
  }
  isOpen() {
    return this._isOpen();
  }
  openModal() {
    this._isOpen.set(true);
  }
  closeModal() {
    this._isOpen.set(false);
  }

}
